import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material"; // Required for Modal styling
import { useSelector, useDispatch } from "react-redux";
import { useSelectedUserId } from '../../SelectedUserIdContext';
import { FormControlLabel, Checkbox, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { postRebalance, GetStrategyVariance, RebalanceLots } from "../../Redux/Actions/transactionService";
import RebalanceConfirmationModal from '../Rebalancing/RebalanceConfirmationModal';
import RebalanceResultModal from '../Rebalancing/RebalanceResultModal';
import UserWiseRebalanceModal from '../Rebalancing/UserWiseRebalanceModal';
import { Alert, Snackbar } from '@mui/material';
import { closeSuccessAlert } from '../../Redux/Reducers/transactionReducer';
import customSuccessAlert from "../../Alerts/customSuccessAlert";
import { useNavigate } from 'react-router-dom';

const ExpandableRowTable = ({ data, onSelectionChange, setShowManual, setShowAuto }) => {
  const [Portfolio, setPortfolio] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const { lots } = useSelector((state) => state.transaction);
  const { setSelectedUserIds } = useSelectedUserId();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [userWiseConfirmation, setUserWiseConfirmation] = useState(false);
  const [userWiseData, setUserWiseData] = useState([]);
  const [rebalanceData, setRebalanceData] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);
  
  const dispatch = useDispatch();
  const [selectedWashTrades, setSelectedWashTrades] = useState({});
  const { strategyData } = useSelector((state) => state.transaction);
  const [rebalanceStatus, setRebalanceStatus] = useState({ success: [], failed: [] });
  const { showSuccessAlert } = useSelector((state) => state.transaction);
  const navigate = useNavigate();

  const sumPositiveVariances = (assetsVariance) => {
    return assetsVariance.reduce((sum, asset) => {
      if (asset.variance > 0) {
        return sum + asset.variance;
      }
      return sum;
    }, 0);
  };

  const aggregateAssetsByUser = (userRoleId, lots) => {
    const aggregatedAssets = {};

    lots.forEach((lot) => {
      if (lot.userRoleId === userRoleId) {
        const assetId = lot.asset.id;

        if (!aggregatedAssets[assetId]) {
          aggregatedAssets[assetId] = {
            assetName: lot.asset.name || "-",
            shortTermGain: 0,
            shortTermLoss: 0,
            longTermGain: 0,
            longTermLoss: 0,
            cumulativeDaysHeld: 0,
            totalLots: 0,
            details: [],
          };
        }

        if (lot.shortTermPnL > 0) {
          aggregatedAssets[assetId].shortTermGain += lot.shortTermPnL;
        } else {
          aggregatedAssets[assetId].shortTermLoss += lot.shortTermPnL;
        }

        if (lot.longTermPnL > 0) {
          aggregatedAssets[assetId].longTermGain += lot.longTermPnL;
        } else {
          aggregatedAssets[assetId].longTermLoss += lot.longTermPnL;
        }

        aggregatedAssets[assetId].cumulativeDaysHeld = 
          (aggregatedAssets[assetId].cumulativeDaysHeld * aggregatedAssets[assetId].totalLots + (lot.daysHeld || 0)) / 
          (aggregatedAssets[assetId].totalLots + 1);
        aggregatedAssets[assetId].totalLots += 1;
        aggregatedAssets[assetId].details.push(lot);
      }
    });

    return Object.values(aggregatedAssets);
  };

  useEffect(() => {
    if (data) {
      setOriginalData(data);
      const processedData = data.map((item) => ({
        id: item?.userRole?.id,
        Investors: item?.userRole?.user?.userInfo?.firstName || "-",
        PortfolioValue: item.totalPortfolio,
        Variance: sumPositiveVariances(item?.assetsVariance),
        GainLoss: item.totalPnL,
        Returns: item.totalReturns,
        LastRebalancingDate: item.lastRebalancedAt? new Date(item.lastRebalancedAt).toLocaleDateString() : "-",
        assetsVariance: item.assetsVariance
      }));
      setPortfolio(processedData);
    }
  }, [data]);

  // const handleActionClick = (userRoleId) => {
  //   const assets = aggregateAssetsByUser(userRoleId, lots);
  //   setModalData(assets);
  //   setShowModal(true);
  // };

  // const formatPnLValue = (value) => {
  //   if (value < 0) {
  //     return <span style={{ color: 'red' }}>({Math.abs(value).toFixed(2)})</span>;
  //   } else if (value > 0) {
  //     return <span style={{ color: 'green' }}>{value.toFixed(2)}</span>;
  //   }
  //   return "0.00";
  // };



  const handleSeeDetails = (row) => {
    const userLots = lots.filter(
      (lot) => lot.userRoleId === row.id
    );
    const aggregatedAssets = aggregateAssetsByUser(row.id, userLots);
    setModalData(aggregatedAssets);
    setShowModal(true);
  };

  const renderModalContent = () => {
    return (
      <Box sx={{ minWidth: 650, maxHeight: '70vh', overflowY: 'auto' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#F8F9FA' }}>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Asset</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Short Term Gain</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Short Term Loss</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Long Term Gain</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Long Term Loss</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Days Held</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modalData.map((asset, index) => (
                <TableRow 
                  key={index}
                  sx={{
                    '&:hover': { backgroundColor: '#F8F9FA' },
                    '& td': { borderBottom: '1px solid #E0E0E0' }
                  }}
                >
                  <TableCell sx={{ color: '#333333' }}>{asset.assetName}</TableCell>
                  <TableCell sx={{ color: '#2E7D32' }}>
                    ${Math.abs(asset.shortTermGain).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ color: '#D32F2F' }}>
                    ${Math.abs(asset.shortTermLoss).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ color: '#2E7D32' }}>
                    ${Math.abs(asset.longTermGain).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ color: '#D32F2F' }}>
                    ${Math.abs(asset.longTermLoss).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ color: '#333333' }}>
                    {Math.round(asset.cumulativeDaysHeld)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Lot Details Section */}
        <Typography 
          variant="h6" 
          sx={{ 
            mt: 4, 
            mb: 2,
            fontSize: '16px',
            fontWeight: 500,
            color: '#1A1A1A'
          }}
        >
          Lot Details
        </Typography>
        
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#F8F9FA' }}>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Asset</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Quantity</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Cost Price</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Market Price</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Days Held</TableCell>
                <TableCell sx={{ fontWeight: 500, color: '#333333' }}>P&L</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modalData.map((asset) =>
                asset.details.map((lot, index) => {
                  // Convert values to numbers and handle null/undefined
                  const quantity = parseFloat(lot.quantity) || 0;
                  const costPrice = parseFloat(lot.costPrice) || 0;
                  const marketPrice = parseFloat(lot.marketPrice) || 0;
                  const shortTermPnL = parseFloat(lot.shortTermPnL) || 0;
                  const longTermPnL = parseFloat(lot.longTermPnL) || 0;
                  const totalPnL = shortTermPnL + longTermPnL;

                  return (
                    <TableRow 
                      key={`${asset.assetName}-${index}`}
                      sx={{
                        '&:hover': { backgroundColor: '#F8F9FA' },
                        '& td': { borderBottom: '1px solid #E0E0E0' }
                      }}
                    >
                      <TableCell sx={{ color: '#333333' }}>{asset.assetName}</TableCell>
                      <TableCell sx={{ color: '#333333' }}>{quantity.toFixed(2)}</TableCell>
                      <TableCell sx={{ color: '#333333' }}>${costPrice.toFixed(2)}</TableCell>
                      <TableCell sx={{ color: '#333333' }}>${marketPrice.toFixed(2)}</TableCell>
                      <TableCell sx={{ color: '#333333' }}>{lot.daysHeld || 0}</TableCell>
                      <TableCell sx={{ 
                        color: totalPnL >= 0 ? '#2E7D32' : '#D32F2F'
                      }}>
                        ${totalPnL.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const columns = [
    { name: "Investors" },
    { name: "Portfolio Value in Strategy" },
    { name: "Variance" },
    { name: "Gain (loss)" },
    { name: "Returns" },
    { name: "Latest rebalancing date" },
    { name: "Action" }, // New column for the action button
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard", 
    rowsPerPage: 10,
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      const ids = allRowsSelected?.map((row) => originalData[row.dataIndex]?.userRole?.id);
      setSelectedUserIds(ids);
      if (onSelectionChange) onSelectionChange(ids);
    },
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    
    if (isChecked) {
      // Select all rows
      const allUserIds = Portfolio.map(row => row.id);
      setSelectedRows(allUserIds);
      // Update parent component if needed
      if (onSelectionChange) {
        onSelectionChange(allUserIds);
      }
      // Update selected user IDs context
      setSelectedUserIds(allUserIds);
    } else {
      // Deselect all rows
      setSelectedRows([]);
      // Update parent component if needed
      if (onSelectionChange) {
        onSelectionChange([]);
      }
      // Update selected user IDs context
      setSelectedUserIds([]);
    }
  };

  const handleRowSelect = (event, id) => {
    const isChecked = event.target.checked;
    let newSelectedRows;

    if (isChecked) {
      newSelectedRows = [...selectedRows, id];
    } else {
      newSelectedRows = selectedRows.filter(rowId => rowId !== id);
    }

    setSelectedRows(newSelectedRows);
    
    // Update selectAll state based on whether all rows are selected
    setSelectAll(newSelectedRows.length === Portfolio.length);
    
    // Update parent component if needed
    if (onSelectionChange) {
      onSelectionChange(newSelectedRows);
    }
    
    // Update selected user IDs context
    setSelectedUserIds(newSelectedRows);
  };

  const formatNumber = (value, decimals = 3) => {
    if (value == null) return "0";
  
    const n = Number(value);
  
    // If number is too big or too small → keep exponential
    if (Math.abs(n) >= 1e9 || (Math.abs(n) > 0 && Math.abs(n) < 1e-3)) {
      return n.toExponential(decimals); // e.g. "5.000e+21"
    }
  
    // Otherwise → normal fixed decimal
    return n.toFixed(decimals);
  };
  

  const handleRebalanceClick = async () => {
    if (selectedRows.length === 0) return;

    // Get selected investor data
    const selectedInvestorData = data.filter(item => 
      selectedRows.includes(item.userRole.id)
    ).map(item => ({
      id: item.userRole.id,
      name: item.userRole.user?.userInfo?.firstName || '-',
      email: item.userRole.user?.email || '-',
      fullData: item
    }));
    
    if (setShowAuto) {
      setShowAuto(true, selectedInvestorData);
    }
  };

  const handleManualRebalanceClick = () => {
    if (setShowManual) {
      // Get selected investor data
      const selectedInvestorData = data.filter(item => 
        selectedRows.includes(item.userRole.id)
      ).map(item => ({
        id: item.userRole.id,
        name: item.userRole.user?.userInfo?.firstName || '-',
        email: item.userRole.user?.email || '-',
        fullData: item
      }));
      
      setShowManual(true, selectedInvestorData);
    }
  };

  const handleWashTradeChange = (userId, assetId) => {
    const key = `${userId}-${assetId}`;
    setSelectedWashTrades(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleConfirmRebalance = async () => {
    setConfirmationOpen(false);
    const userWiseAssets = data
      .filter(userData => selectedRows.includes(userData.userRole.id))
      .map(userData => ({
        userId: userData.userRole.id,
        userEmail: userData.userRole.user?.email || '-',
        firstName: userData.userRole.user?.userInfo?.firstName || '-',
        lastName: userData.userRole.user?.userInfo?.lastName || '',
        assets: userData.assetsVariance.map(asset => ({
          ...asset,
          symbol: asset.asset.symbol,
          currentAmount: parseFloat(asset.currentPortfolio || 0).toFixed(2),
          newAmount: parseFloat(asset.idealPortfolio || 0).toFixed(2),
          buySellAmount: (parseFloat(asset.idealPortfolio || 0) - parseFloat(asset.currentPortfolio || 0)).toFixed(2),
          isWashTrade: asset.isWashTrade,
          assetId: asset.asset.id
        }))
      }));

    setUserWiseData(userWiseAssets);
    setSelectedWashTrades({});
    setUserWiseConfirmation(true);
  };

  const handleFinalConfirm = async () => {
    const pathSegments = window.location.pathname.split('/');
    const strategyId = pathSegments[pathSegments.length - 1];
    const EntityId = localStorage.getItem("entId");
    const userInfoString = localStorage.getItem("userInfo");
    const userInfo = userInfoString && userInfoString !== "undefined" ? JSON.parse(userInfoString) : null;
    const role = userInfo?.portal || 'MANAGER';

    const userRoleAssets = userWiseData.map(userData => ({
      userRoleId: userData.userId,
      assets: userData.assets.map(asset => ({
        symbol: asset.symbol,
        isWash: !!selectedWashTrades[`${userData.userId}-${asset.assetId}`]
      }))
    }));

    const body = {
      type: "MKT",
      strategyId: strategyId,
      userRoleAssets
    };

    try {
      const response = await dispatch(postRebalance({ body, role }));
      if (response.payload.statusCode === 201) {
        customSuccessAlert("Rebalanced Successfully")
        setUserWiseConfirmation(false);
        setSelectedRows([]);
        dispatch(GetStrategyVariance({  strategyId }));
        // Show success alert
        dispatch(closeSuccessAlert());
      }
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2
      }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontSize: '16px',
            color: '#1A1A1A',
            fontWeight: 500
          }}
        >
          Investor Portfolio Details
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox 
                checked={selectAll}
                onChange={handleSelectAll}
                sx={{
                  color: '#1976D2',
                  '&.Mui-checked': {
                    color: '#1976D2',
                  },
                }}
              />
            }
            label="Select All"
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                color: '#666666'
              }
            }}
          />
          <Button
            variant="contained"
            onClick={handleManualRebalanceClick}
            disabled={isButtonDisabled || selectedRows.length === 0}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
              backgroundColor: '#1976D2',
              '&:hover': {
                backgroundColor: '#1565C0'
              },
              '&.Mui-disabled': {
                backgroundColor: '#E0E0E0',
                color: '#666666'
              }
            }}
          >
            Manual Rebalance
          </Button>
          <Button
            variant="contained"
            onClick={handleRebalanceClick}
            disabled={isButtonDisabled || selectedRows.length === 0}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
              backgroundColor: '#1976D2',
              '&:hover': {
                backgroundColor: '#1565C0'
              },
              '&.Mui-disabled': {
                backgroundColor: '#E0E0E0',
                color: '#666666'
              }
            }}
          >
           Auto Rebalance
          </Button>
        </Box>
      </Box>

      <TableContainer component={Paper} sx={{ 
        borderRadius: '8px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)'
      }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#F8F9FA' }}>
              <TableCell padding="checkbox">
                {/* Removed checkbox from header, keeping empty cell for alignment */}
              </TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Investor</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Portfolio Value in Strategy</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>% Variance</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Gain/Loss</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Returns</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Last Rebalancing Date</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#333333' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Portfolio.map((row, index) => (
             
              <TableRow 
                key={index}
                sx={{
                  '&:hover': { backgroundColor: '#F8F9FA' },
                  '& td': { borderBottom: '1px solid #E0E0E0' }
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={(event) => handleRowSelect(event, row.id)}
                    sx={{
                      color: '#1976D2',
                      '&.Mui-checked': {
                        color: '#1976D2',
                      },
                    }}
                  />
                </TableCell>
                <TableCell sx={{ color: '#333333' }}>{row.Investors}</TableCell>
                <TableCell sx={{ color: '#333333' }}>${row.PortfolioValue?.toFixed(2)}</TableCell>
                <TableCell sx={{ color: row.Variance >= 0 ? '#2E7D32' : '#D32F2F' }}>
                  {row.Variance?.toFixed(2)}%
                </TableCell>
                <TableCell sx={{ color: row.GainLoss >= 0 ? '#2E7D32' : '#D32F2F' }}>
                  ${Math.abs(row.GainLoss)?.toFixed(2)}
                </TableCell>
                <TableCell sx={{ color: row.Returns >= 0 ? '#2E7D32' : '#D32F2F' }}>
                  {row.Returns?.toFixed(2)}%
                </TableCell>
                <TableCell sx={{ color: '#333333' }}>{row.LastRebalancingDate}</TableCell>
                <TableCell>
                  <Button
                    variant="text"
                    onClick={() => handleSeeDetails(row)}
                    sx={{
                      textTransform: 'none',
                      color: '#1976D2',
                      fontSize: '14px',
                      '&:hover': {
                        backgroundColor: 'transparent',
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    See Lot Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Lot Details Modal */}
      <Modal 
        open={showModal} 
        onClose={() => setShowModal(false)}
        BackdropProps={{ style: { backdropFilter: 'blur(8px)' } }}
      >
        <Box sx={{ 
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '8px',
          maxWidth: '90%',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: 3
          }}>
            <Typography variant="h6" sx={{ 
              fontSize: '20px',
              fontWeight: 500,
              color: '#1A1A1A'
            }}>
              Asset Details
            </Typography>
            <Button
              onClick={() => setShowModal(false)}
              variant="outlined"
              sx={{
                textTransform: 'none',
                color: '#666666',
                borderColor: '#E0E0E0',
                '&:hover': {
                  borderColor: '#BDBDBD',
                  backgroundColor: 'transparent'
                }
              }}
            >
              Close
            </Button>
          </Box>
          {renderModalContent()}
        </Box>
      </Modal>

      {/* Add confirmation modals */}
      <RebalanceConfirmationModal 
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        isFullscreen={isFullscreen}
        rebalanceData={rebalanceData}
        onConfirm={handleConfirmRebalance}
        setIsFullscreen={setIsFullscreen}
      />

      <UserWiseRebalanceModal 
        open={userWiseConfirmation}
        onClose={() => setUserWiseConfirmation(false)}
        userWiseData={userWiseData}
        selectedWashTrades={selectedWashTrades}
        handleWashTradeChange={handleWashTradeChange}
        handleFinalConfirm={handleFinalConfirm}
        strategyName={strategyData?.[0]?.strategy?.name || '-'}
      />

      <RebalanceResultModal 
        open={resultOpen}
        onClose={() => {
          setResultOpen(false);
          setRebalanceStatus({ success: [], failed: [] });
        }}
        status={rebalanceStatus}
      />

      <Snackbar
        open={showSuccessAlert}
        autoHideDuration={3000}
        onClose={() => dispatch(closeSuccessAlert())}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => dispatch(closeSuccessAlert())}
          severity="success"
          sx={{
            width: '100%',
            bgcolor: '#EDF7ED',
            '& .MuiAlert-icon': {
              color: '#2E7D32'
            }
          }}
        >
          Rebalance completed successfully
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ExpandableRowTable;
